class Overlay {
    constructor() {
        this.element = this.showoverlay();
    }
    showoverlay() {
        var overlay = document.createElement('div');
        overlay.id = 'overlay';
        overlay.className = 'overlay';
        doek.element.appendChild(overlay);

        return overlay;
    }
}

export default Overlay;